import apiClient from '@u/apiClient'

let base_errors = {}
export default {
  //region fetch
  async fetchMessageTextList({ commit }) {
    await apiClient
      .get('api/messageText')
      .then(async (response) => {
        commit('setMessageTextList', response.data.message_texts)
        commit('setMessageTextMetadata', response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchMessageTextList', reason)
      })
  },
  async fetchMessageTextById({ commit }, payload) {
    commit('auth/setErrors', base_errors, { root: true })
    await apiClient
      .get(`api/messageText/${payload.id}`)
      .then(async (response) => {
        commit('setMessageText', await response.data.message_text)
        commit('setMessageTextMetadata', await response.data.metadata)
      })
      .catch(async (reason) => {
        console.error('fetchMessageTextById', reason)
      })
  },
  async fetchNewMessageText({ commit }) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .get(`api/model/new?model=messageText`)
      .then(async (response) => {
        commit('setMessageText', response.data.messageText)
        commit('setMessageTextMetadata', response.data.metadata)
      })
      // Already toasted by apiClient.
      .catch(() => {})
  },
  fetchMessageTextConverted({ commit }, payload) {
    return apiClient
      .post(`/api/convertMessageText`, payload)
      .then((response) => {
        commit('setMessageText', response.data.text)
        return response.data
      })
  },
  //endregion

  //region store
  storeMessageText({ commit }, payload) {
    return apiClient
      .post('api/messageText', payload.messageText)
      .then(async (response) => {
        commit('setMessageTextList', response.data.message_texts)
        commit('setMessageTextMetadata', response.data.metadata)
        return response.data
      })
  },
  //endregion

  //region update
  updateMessageText({ commit }, payload) {
    return apiClient
      .put(`api/messageText/${payload.messageText.id}`, payload.messageText)
      .then(async (response) => {
        commit('setMessageTextList', response.data.message_texts)
        commit('setMessageTextMetadata', response.data.metadata)
        return response.data
      })
  },
  //endregion

  //region delete
  deleteMessageTextById({ commit }, payload) {
    return apiClient
      .delete(`api/messageText/${payload.id}`)
      .then(async (response) => {
        commit('setMessageTextList', response.data.message_texts)
        commit('setMessageTextMetadata', response.data.metadata)
        return response.data
      })
  },
  //endregion

  //region undoDelete
  undoDeleteMessageTextById({ commit }, payload) {
    return apiClient
      .get(`api/messageText/undo-delete/${payload.id}`)
      .then(async (response) => {
        commit('setMessageTextList', response.data.message_texts)
        commit('setMessageTextMetadata', response.data.metadata)
        return response.data
      })
  }
  //endregion
}
